/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PatchAgentGraphPathParams = NonNullable<operations['patchAgentGraph']['parameters']['path']>;

export type PatchAgentGraphRequestBody = OperationRequestBodyContent<operations['patchAgentGraph']>;

export interface Input extends PatchAgentGraphPathParams {
  apiVersion?: string;
  body: PatchAgentGraphRequestBody;
  header: NonNullable<operations['patchAgentGraph']['parameters']['header']>;
}

export async function patchAgentGraph(
  { apiVersion, body, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PATCH('/api/v2/projects/{projectKey}/agent-graphs/{graphKey}', {
    params: { path, header },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
